import { FormBase } from 'core/components';

export default class MarkAsShippedLtlForm extends FormBase {
	constructor(hooks) {
		super(hooks);
		this.setForm(this);
	}
	setup() {
		return {
			fields: [
				{
					name: 'trackingNumber',
					label: 'FULFILLMENTORDER.MARKASSHIPPEDMODAL.TRACKINGNUMBER',
					rules: 'required',
				},
				{
					name: 'carrierId',
					label: 'FULFILLMENTORDER.MARKASSHIPPEDMODAL.CARRIER',
					rules: 'required',
				},
				{
					name: 'isInternal',
					value: true,
					type: 'checkbox',
				},
			],
		};
	}
}
